import React, { useState, useEffect } from "react";
import Box from "@mui/material/Box";
import Drawer from "@mui/material/Drawer";
import List from "@mui/material/List";
import ListItemButton from "@mui/material/ListItemButton";
import ListItemText from "@mui/material/ListItemText";
import { useSelector } from "react-redux";
import ExpandLess from "@mui/icons-material/ExpandLess";
import ExpandMore from "@mui/icons-material/ExpandMore";
import { Collapse, IconButton, ListItem, } from "@mui/material";
import { useNavigate } from "react-router-dom";
import OpenInNewIcon from "@mui/icons-material/OpenInNew";
import { ListItemContainer } from "./Styled.components";
import { buildUrl, buildMenu } from "../../../utils";

export const ListMenuMobile = ({ open, toggleDrawer }: any) => {
  const { modules } = useSelector((state: any) => state.user);
  const [menu, setMenu] = useState<any>([]);
  const [expand, setExpand] = useState<any>({});
  const [expandSub, setExpandSub] = useState<any>({});
  const history = useNavigate();
  const { modo } = useSelector((state: any) => state.user);



  useEffect(() => {
    if (!modules) return;

    const expand: Record<string, boolean> = {};
    const expandSub: Record<string, boolean> = {};
    const menus = buildMenu(modules, expand, expandSub);

    setExpand(expand);
    setExpandSub(expandSub);
    setMenu(menus);
  }, [modules]);


  const handleClick =
    (name: any = null) =>
      (event: any) => {
        let keys: any = {};
        Object.keys(expand).map((k: any) => {
          keys[k] = false;
        });
        if (name !== null) {
          keys = { ...keys, [name]: !expand[name] };
        } else {
          handleClickSub()(event);
        }
        setExpand(keys);
      };
  const handleClickSub =
    (name: any = null) =>
      (event: any) => {
        let keys: any = {};
        Object.keys(expandSub).map((k: any) => {
          keys[k] = false;
        });
        if (name !== null) {
          keys = { ...keys, [name]: !expandSub[name] };
        }
        setExpandSub(keys);
      };

  const toogleMenu =
    (url: string, newWindow: any = null) =>
      (event: any) => {
        toggleDrawer(false)(event);
        if (newWindow) {
          window.open(url, "_blank", "noopener,noreferrer");
        } else {
          history(url);
        }
      };

  const list = () => (
    <Box
      sx={{ width: "100%" }}
      role="presentation"
      style={{ fontFamily: "MontserratRegular" }}
    // onClick={toggleDrawer(false)}
    // onKeyDown={toggleDrawer(false)}
    >
      <List>
        {menu.map((menu: any, i: number) => (
          <React.Fragment key={i}>
            <ListItemContainer
              expand={expand[menu.key]}
              modo={modo}
              secondaryAction={
                menu.children.length > 0 ? (
                  <IconButton
                    onClick={handleClick(menu.key)}
                    edge="end"
                    aria-label="comments"
                  >
                    {expand[menu.key] ? <ExpandLess /> : <ExpandMore />}
                  </IconButton>
                ) : null
              }
            >
              <ListItemButton onClick={toogleMenu(menu.url)}>
                <ListItemText primary={menu.text} />
              </ListItemButton>
            </ListItemContainer>
            <Collapse in={expand[menu.key]} timeout="auto" unmountOnExit>
              <List component="div" sx={{ pl: 4 }}>
                {menu.children.map((subMenu: any, index: number) => (
                  <React.Fragment key={index}>
                    <ListItemContainer
                      expand={expandSub[subMenu.key]}
                      modo={modo}
                      secondaryAction={
                        subMenu.children.length > 0 ? (
                          <IconButton
                            onClick={handleClickSub(subMenu.key)}
                            edge="end"
                            aria-label="comments"
                          >
                            {expandSub[subMenu.key] ? (
                              <ExpandLess />
                            ) : (
                              <ExpandMore />
                            )}
                          </IconButton>
                        ) : null
                      }
                      disablePadding
                    >
                      {subMenu.url.split("/")[2] ? (
                        <ListItemButton onClick={toogleMenu(subMenu.url)}>
                          <ListItemText primary={subMenu.text} />
                        </ListItemButton>
                      ) : (
                        <ListItemText
                          sx={{
                            paddingLeft: 2,
                            paddingTop: "8px",
                            paddingBottom: "8px",
                          }}
                          primary={subMenu.text}
                        />
                      )}
                    </ListItemContainer>
                    <Collapse
                      in={expandSub[subMenu.key]}
                      timeout="auto"
                      unmountOnExit
                    >
                      <List component="div" sx={{ pl: 2 }}>
                        {subMenu.children.map((vista: any, iP: number) => (
                          <ListItem
                            secondaryAction={
                              <IconButton
                                style={{
                                  color:
                                    modo === "oscuro" ? "#E6E6E6" : "#3C3B39",
                                }}
                                onClick={toogleMenu(vista.url, true)}
                                edge="end"
                                aria-label="comments"
                              >
                                <OpenInNewIcon />
                              </IconButton>
                            }
                            key={iP}
                          >
                            <ListItemButton onClick={toogleMenu(vista.url)}>
                              <ListItemText primary={vista.text} />
                            </ListItemButton>
                          </ListItem>
                        ))}
                      </List>
                    </Collapse>
                  </React.Fragment>
                ))}
              </List>
            </Collapse>
          </React.Fragment>
        ))}
      </List>
    </Box>
  );

  return (
    <div>
      <Drawer
        anchor="left"
        open={open}
        onClose={toggleDrawer(false)}
        sx={{
          "&.MuiDrawer-modal": { position: "static" },
        }}
        PaperProps={{
          sx: {
            width: "100%",
            marginTop: "71px",
            paddingBottom: "71px",
            paddingLeft: "20px",
            paddingRight: "20px",
            backgroundColor: modo === "oscuro" ? "#3C3B39" : "white",
            color: modo === "oscuro" ? "#E6E6E6" : "#3C3B39",
          },
        }}
      >
        {list()}
      </Drawer>
    </div>
  );
};
